import client from "./client";

export const settingsApi = {
  get:    ()     => client.get("/settings"),
  update: (data) => client.patch("/settings", data),
};

export const llmConfigApi = {
  get:    ()     => client.get("/admin/llm-config"),
  save:   (data) => client.put("/admin/llm-config", data),
  test:   (data) => client.post("/admin/llm-config/test", data),
};

export const ragConfigApi = {
  get:        ()     => client.get("/settings/rag"),
  save:       (data) => client.patch("/settings/rag", data),
  reindexAll: ()     => client.post("/rag/documents/reindex-all"),
};
